import { api } from './client'
import type { CommonLibraryPage } from '@/types'

export function fetchCommonLibrary(groupId: string): Promise<CommonLibraryPage> {
  return api.get<CommonLibraryPage>(`/groups/${groupId}/common-library`)
}
